<div class="flex flex-col gap-4 mt-2">
  <div class="soft-card flex flex-col py-2">
    <p class="font-semibold">{{ bewe().lfdnr | number: '3.0' }}</p>
    <p class="font-semibold text-base">{{ bewe().artikelMenge.artikel.artbez1 ?? 'Artikel' }}</p>
    <p class="text-sm text-light" data-testid="pallet-detail-progress">
      {{ '#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.PALETTE' | translate }}
      {{ palletIndex() + 1 }} / {{ palletCount() }}
    </p>
  </div>

  <div class="flex flex-col gap-2">
    <soft-ds-input
      data-testid="pallet-detail-sscc"
      [label]="'#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.SSCC' | translate"
      [placeholder]="'#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.SSCC_PLACEHOLDER' | translate"
      [value]="sscc()"
      (valueChange)="sscc.set($event ?? null)"
    />
    <soft-scan-button data-testid="pallet-detail-scan" />
  </div>

  <soft-ds-input
    data-testid="pallet-detail-charge"
    [label]="'#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.CHARGENNUMMER' | translate"
    [placeholder]="'#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.CHARGENNUMMER' | translate"
    [value]="batchNumber()"
    (valueChange)="batchNumber.set($event ?? null)"
  />

  <div class="flex flex-col gap-1">
    <span class="font-bold text-sm text-primary-400">
      {{ '#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.MENGE' | translate }}
    </span>
    <soft-mengen-eingabe
      data-testid="pallet-detail-menge"
      [einheit]="unit()"
      [float]="true"
      [value]="quantity()"
      [preventKeyboardEventEmission]="true"
      (valueChange)="quantity.set($event)"
    />
  </div>

  <button
    class="soft-button primary rounded-sm h-16 w-full"
    (click)="confirm()"
  >
    {{
      (palletIndex() + 1 < palletCount()
          ? '#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.WEITER'
          : '#WWS_WARENUEBERNAHME.DIALOG.PALLET_DETAIL.ZUR_UEBERSICHT'
      ) | translate
    }}
  </button>
</div>
